import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {TuiStatus} from '@taiga-ui/kit';
import {StatusHistory} from '@gatewee/types/system';
import {UtilsModule} from '@gatewee/utils';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

/**
 * TODO: Migrate to GateweeStatusHistoryComponent (gatewee-status-history)
 * with configurable titleKey / emptyKey / statusI18nPrefix / statusColorFn.
 */
@Component({
  selector: 'gatewee-invoice-status-history',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
    TuiStatus,
  ],
  templateUrl: './gatewee-invoice-status-history.component.html',
  styleUrls: [
    './gatewee-invoice-status-history.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeInvoiceStatusHistoryComponent {
  @Input() statusHistory: StatusHistory[] | null | undefined;

  get items(): StatusHistory[] {
    return this.statusHistory ?? [];
  }

  /** Hex colors for Taiga `tuiStatus` — aligned with invoice view and gatewee-table-v2. */
  statusTuiColor(status: string): string {
    const s = (status || '').toLowerCase();
    if (
      [
        'paid',
        'confirmed',
        'success',
        'cashed_out',
        'active',
        'fixed',
      ].includes(s)
    ) {
      return '#39B54A';
    }
    if (['failed', 'canceled', 'rejected', 'expired', 'past_due'].includes(s)) {
      return '#FF7043';
    }
    if (
      [
        'pending',
        'pending_generation',
        'in_dispute',
        'pending_refund',
      ].includes(s)
    ) {
      return '#FFD54F';
    }
    if (['refunded', 'variable'].includes(s)) {
      return '#79818C';
    }
    return '#526ED3';
  }

  hasMetadata(metadata: Record<string, unknown>): boolean {
    return !!metadata && Object.keys(metadata).length > 0;
  }
}
